import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "card-container__inner" }
const _hoisted_3 = { class: "card-container__header" }
const _hoisted_4 = { class: "card-container__title title title--tertiary" }
const _hoisted_5 = { class: "card-container__body" }
const _hoisted_6 = { class: "carousel__item card-container__item" }
const _hoisted_7 = { class: "service-card-primary__inner" }
const _hoisted_8 = { class: "service-card-primary__header" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "service-card-primary__subtitle" }
const _hoisted_11 = { class: "service-card-primary__body" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "service-card-primary__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t('popular_services')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_swiper, {
          "slides-per-view": 6,
          "space-between": 10,
          breakpoints: _ctx.breakpoints,
          pagination: _ctx.pagination,
          modules: _ctx.modules,
          navigation: false,
          class: "mySwiper"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceList, (service) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                key: service.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['service-card-primary', {'service-card-primary--all': (service.id === 9999)}])
                    }, [
                      _createVNode(_component_router_link, {
                        class: "service-card-primary__link",
                        to: service.id === 9999 ? {name: 'service-category'} : { name: 'service', params: { id: service.id, name: service.name, fromMain: true }}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", {
                                class: "service-card-primary__title",
                                title: service.name
                              }, _toDisplayString(service.name), 9, _hoisted_9),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(service.catalog_name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              (service.icon)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: service.icon,
                                    alt: "icon",
                                    class: "service-card-primary__img"
                                  }, null, 8, _hoisted_12))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(service.description), 1))
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "service-card-primary__footer" }, [
                              _createElementVNode("div", { class: "service-card-primary__arrow" }, [
                                _createElementVNode("svg", {
                                  id: "arrow",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 16 16",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M9.5 13L14 8M14 8L9.5 3M14 8L2 8",
                                    stroke: "#6059F4",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  })
                                ])
                              ])
                            ], -1))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 2)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["breakpoints", "pagination", "modules"]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "swp-pagination" }, null, -1))
      ])
    ])
  ]))
}